export enum TodoErrorType {
  UnableToLoadTodos = 'Unable to load todos',
  UnableToAddTodo = 'Unable to add a todo',
  UnableToDeleteTodo = 'Unable to delete a todo',
  UnableToUpdateTodo = 'Unable to update a todo',
  EmptyTitle = 'Title should not be empty',
  None = '',
}
